import React from 'react'
import NoDataImage from 'assets/images/no-data-found.png'
import { MainWrapper, Wrapper, IconWrapper, ContentWrapper, MainHeading } from 'styles/NoDataFound'

const NoDataFound = ({ content }) => (
  <MainWrapper>
    <Wrapper>
      <IconWrapper>
        <img src={NoDataImage} alt="no-data" />
      </IconWrapper>
      <ContentWrapper>
        <MainHeading>{content}</MainHeading>
      </ContentWrapper>
    </Wrapper>
  </MainWrapper>
)

export default NoDataFound
